// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/work_item.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { FilterGroup, PageRequest, PageResponse, SortSpec } from "./common_pb.js";

/**
 * @generated from enum omnios.v1.WorkItemKind
 */
export const WorkItemKind = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.WorkItemKind",
  [
    {no: 0, name: "WORK_ITEM_KIND_UNSPECIFIED"},
    {no: 1, name: "CASE"},
    {no: 2, name: "TASK"},
    {no: 3, name: "SUB_TASK"},
  ],
);

/**
 * @generated from enum omnios.v1.MatchMode
 */
export const MatchMode = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.MatchMode",
  [
    {no: 0, name: "MATCH_MODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MATCH_MODE_FAST", localName: "FAST"},
    {no: 2, name: "MATCH_MODE_ACCURATE", localName: "ACCURATE"},
  ],
);

/**
 * Unified work tracking: cases, tasks, sub-tasks
 * Replaces Case + Ticket
 *
 * @generated from message omnios.v1.WorkItem
 */
export const WorkItem = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WorkItem",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "kind", kind: "enum", T: proto3.getEnumType(WorkItemKind) },
    { no: 5, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "type_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "status_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "priority_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "deadline", kind: "message", T: Timestamp },
    { no: 14, name: "attrs", kind: "message", T: Struct },
    { no: 20, name: "created_at", kind: "message", T: Timestamp },
    { no: 21, name: "updated_at", kind: "message", T: Timestamp },
    { no: 22, name: "deleted_at", kind: "message", T: Timestamp },
    { no: 30, name: "assignees", kind: "message", T: WorkItemPartyLink, repeated: true },
    { no: 31, name: "customer", kind: "message", T: WorkItemPartyLink },
    { no: 32, name: "sub_items", kind: "message", T: WorkItem, repeated: true },
    { no: 33, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 34, name: "type_config", kind: "message", T: ConfigOption },
    { no: 35, name: "status_config", kind: "message", T: ConfigOption },
    { no: 36, name: "priority_config", kind: "message", T: ConfigOption },
  ],
);

/**
 * @generated from message omnios.v1.WorkItemPartyLink
 */
export const WorkItemPartyLink = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WorkItemPartyLink",
  () => [
    { no: 1, name: "work_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Workspace-scoped configurable option (status, type, priority)
 *
 * @generated from message omnios.v1.ConfigOption
 */
export const ConfigOption = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ConfigOption",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "sla_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "is_initial", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * Event emitted on work item changes (for streaming)
 *
 * @generated from message omnios.v1.WorkItemEvent
 */
export const WorkItemEvent = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WorkItemEvent",
  () => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(WorkItemEvent_EventKind) },
    { no: 2, name: "work_item", kind: "message", T: WorkItem },
    { no: 3, name: "actor_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "timestamp", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from enum omnios.v1.WorkItemEvent.EventKind
 */
export const WorkItemEvent_EventKind = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.WorkItemEvent.EventKind",
  [
    {no: 0, name: "EVENT_KIND_UNSPECIFIED"},
    {no: 1, name: "CREATED"},
    {no: 2, name: "UPDATED"},
    {no: 3, name: "STATUS_CHANGED"},
    {no: 4, name: "ASSIGNED"},
    {no: 5, name: "COMMENTED"},
    {no: 6, name: "DELETED"},
  ],
);

/**
 * @generated from message omnios.v1.CreateWorkItemRequest
 */
export const CreateWorkItemRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateWorkItemRequest",
  () => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(WorkItemKind) },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "type_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "status_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "priority_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "deadline", kind: "message", T: Timestamp },
    { no: 10, name: "attrs", kind: "message", T: Struct },
    { no: 11, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "assignee_party_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetWorkItemRequest
 */
export const GetWorkItemRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkItemRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateWorkItemRequest
 */
export const UpdateWorkItemRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateWorkItemRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "status_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "priority_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "type_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "deadline", kind: "message", T: Timestamp },
    { no: 8, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.DeleteWorkItemRequest
 */
export const DeleteWorkItemRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteWorkItemRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListWorkItemsRequest
 */
export const ListWorkItemsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWorkItemsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "filter", kind: "message", T: FilterGroup },
    { no: 3, name: "sort", kind: "message", T: SortSpec },
    { no: 4, name: "kind", kind: "enum", T: proto3.getEnumType(WorkItemKind), opt: true },
    { no: 5, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "review_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "triage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListWorkItemsResponse
 */
export const ListWorkItemsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWorkItemsResponse",
  () => [
    { no: 1, name: "work_items", kind: "message", T: WorkItem, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.AssignWorkItemRequest
 */
export const AssignWorkItemRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AssignWorkItemRequest",
  () => [
    { no: 1, name: "work_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UnassignWorkItemRequest
 */
export const UnassignWorkItemRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UnassignWorkItemRequest",
  () => [
    { no: 1, name: "work_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.LinkWorkItemConversationRequest
 */
export const LinkWorkItemConversationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.LinkWorkItemConversationRequest",
  () => [
    { no: 1, name: "work_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.StreamWorkItemEventsRequest
 */
export const StreamWorkItemEventsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StreamWorkItemEventsRequest",
  () => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(WorkItemKind), opt: true },
  ],
);

/**
 * Config option management
 *
 * @generated from message omnios.v1.CreateConfigOptionRequest
 */
export const CreateConfigOptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateConfigOptionRequest",
  () => [
    { no: 1, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "sla_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "is_initial", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.UpdateConfigOptionRequest
 */
export const UpdateConfigOptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateConfigOptionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "sla_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.DeleteConfigOptionRequest
 */
export const DeleteConfigOptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteConfigOptionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListConfigOptionsRequest
 */
export const ListConfigOptionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListConfigOptionsRequest",
  () => [
    { no: 1, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListConfigOptionsResponse
 */
export const ListConfigOptionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListConfigOptionsResponse",
  () => [
    { no: 1, name: "options", kind: "message", T: ConfigOption, repeated: true },
  ],
);

/**
 * Status transition management
 *
 * @generated from message omnios.v1.StatusTransition
 */
export const StatusTransition = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StatusTransition",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "from_option_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "to_option_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "from_option", kind: "message", T: ConfigOption },
    { no: 7, name: "to_option", kind: "message", T: ConfigOption },
  ],
);

/**
 * @generated from message omnios.v1.CreateStatusTransitionRequest
 */
export const CreateStatusTransitionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateStatusTransitionRequest",
  () => [
    { no: 1, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "from_option_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "to_option_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteStatusTransitionRequest
 */
export const DeleteStatusTransitionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteStatusTransitionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListStatusTransitionsRequest
 */
export const ListStatusTransitionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListStatusTransitionsRequest",
  () => [
    { no: 1, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "from_option_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListStatusTransitionsResponse
 */
export const ListStatusTransitionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListStatusTransitionsResponse",
  () => [
    { no: 1, name: "transitions", kind: "message", T: StatusTransition, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ProductMatchCandidate
 */
export const ProductMatchCandidate = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductMatchCandidate",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "similarity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "category_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "vendor_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "properties", kind: "message", T: Struct },
    { no: 9, name: "selling_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "is_draft", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ProcessOrderUpdate
 */
export const ProcessOrderUpdate = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProcessOrderUpdate",
  () => [
    { no: 1, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "step_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "progress_pct", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "data", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.SearchAlternativesResponse
 */
export const SearchAlternativesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchAlternativesResponse",
  () => [
    { no: 1, name: "candidates", kind: "message", T: ProductMatchCandidate, repeated: true },
    { no: 2, name: "parsed_query", kind: "message", T: ParsedQueryInfo },
    { no: 3, name: "facets", kind: "message", T: FacetGroup, repeated: true },
    { no: 4, name: "relaxation_hints", kind: "message", T: RelaxationHint, repeated: true },
    { no: 5, name: "total_found", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ParsedQueryInfo
 */
export const ParsedQueryInfo = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ParsedQueryInfo",
  () => [
    { no: 1, name: "rewritten_query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "extracted_attributes", kind: "message", T: Struct },
    { no: 3, name: "suggested_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "parsed_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "parsed_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.FacetGroup
 */
export const FacetGroup = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FacetGroup",
  () => [
    { no: 1, name: "field_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "values", kind: "message", T: FacetValue, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.FacetValue
 */
export const FacetValue = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FacetValue",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.RelaxationHint
 */
export const RelaxationHint = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RelaxationHint",
  () => [
    { no: 1, name: "attribute_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "attribute_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "additional_results", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.BulkDeleteWorkItemsRequest
 */
export const BulkDeleteWorkItemsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkDeleteWorkItemsRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "all", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.BulkDeleteWorkItemsResponse
 */
export const BulkDeleteWorkItemsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkDeleteWorkItemsResponse",
  () => [
    { no: 1, name: "deleted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

